<template lang="pug">
#app
	router-view
</template>

<script>

export default {
	name: 'App',
	components: {

	},
	data() {
		return {

		}
	},
}
</script>

<style lang="sass">
@import "@/assets/style/main.sass"
@import "@/assets/style/pages/home.sass"
@import "@/assets/style/common/_forms.sass"
</style>



// WEBPACK FOOTER //
// src/App.vue